var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.1951 40.3811H100.839V93.4664H80.1951V40.3811Z",
    fill: "#DDB200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1606 40.3811H44.8049V93.4664H24.1606V40.3811Z",
    fill: "#DDB200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8049 25.6353H80.1951V99.3648H44.8049V25.6353Z",
    fill: "#FFCD00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7368 99.3647H105.263V105.263H19.7368V99.3647Z",
    fill: "#58595B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5172 89.0427C90.6226 90.451 90.9928 91.8268 91.6084 93.0978C91.6674 93.2158 91.7411 93.3485 91.8001 93.4665H95.1474C95.87 92.0948 96.3018 90.5888 96.4156 89.0427C96.4132 88.2612 96.1018 87.5125 95.5492 86.9599C94.9966 86.4073 94.2479 86.0958 93.4664 86.0935C93.3777 86.0911 93.2889 86.096 93.201 86.1082C92.4682 86.1745 91.7867 86.5122 91.2901 87.0551C90.7936 87.598 90.5179 88.3069 90.5172 89.0427Z",
    fill: "#7ED63E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6085 93.0978C90.9929 91.8268 90.6227 90.451 90.5173 89.0427C90.518 88.307 90.7936 87.598 91.2902 87.0551C91.7867 86.5122 92.4683 86.1745 93.201 86.1083C92.8582 85.1222 92.1769 84.2895 91.2781 83.7583C90.3794 83.227 89.3215 83.0316 88.2922 83.2067C87.263 83.3817 86.3292 83.916 85.6567 84.7145C84.9841 85.513 84.6164 86.5241 84.6189 87.5681C84.752 89.696 85.4886 91.742 86.7423 93.4665H91.8002C91.7412 93.3485 91.6675 93.2158 91.6085 93.0978Z",
    fill: "#5EAC24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7032 78.7205H62.5V99.3647H50.7032V78.7205Z",
    fill: "#57A4FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 78.7205H74.2967V99.3647H62.5V78.7205Z",
    fill: "#2488FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.704 66.9238H59.5515V72.8222H50.704V66.9238Z",
    fill: "#F1F2F2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M65.45 66.9238H74.2975V72.8222H65.45V66.9238Z",
    fill: "#F1F2F2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M50.704 55.1271H59.5515V61.0254H50.704V55.1271Z",
    fill: "#F1F2F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.45 55.1271H74.2975V61.0254H65.45V55.1271Z",
    fill: "#F1F2F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.704 43.3303H59.5515V49.2287H50.704V43.3303Z",
    fill: "#F1F2F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.45 43.3303H74.2975V49.2287H65.45V43.3303Z",
    fill: "#F1F2F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7041 31.5336H59.5517V37.4319H50.7041V31.5336Z",
    fill: "#F1F2F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.45 31.5336H74.2975V37.4319H65.45V31.5336Z",
    fill: "#F1F2F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0942 58.0762H94.9418V63.9745H86.0942V58.0762Z",
    fill: "#F1F2F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0942 69.8729H94.9418V75.7713H86.0942V69.8729Z",
    fill: "#F1F2F2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0942 46.2795H94.9418V52.1779H86.0942V46.2795Z",
    fill: "#F1F2F2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M100.839 40.3812L105.263 34.4828H80.1951V40.3812H100.839Z",
    fill: "#006DF0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4827 89.0427C34.482 88.3069 34.2063 87.598 33.7098 87.0551C33.2133 86.5122 32.5317 86.1745 31.799 86.1082C31.711 86.096 31.6223 86.0911 31.5335 86.0935C30.7521 86.0958 30.0033 86.4073 29.4507 86.9599C28.8982 87.5125 28.5867 88.2612 28.5844 89.0427C28.6982 90.5888 29.1299 92.0948 29.8525 93.4665H33.1998C33.2588 93.3485 33.3325 93.2158 33.3915 93.0978C34.0071 91.8268 34.3773 90.451 34.4827 89.0427Z",
    fill: "#7ED63E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9574 83.1443C35.0418 83.1429 34.1486 83.4279 33.4029 83.9594C32.6573 84.4909 32.0965 85.2422 31.7991 86.1082C32.5318 86.1744 33.2134 86.5122 33.7099 87.0551C34.2065 87.598 34.4821 88.3069 34.4828 89.0427C34.3774 90.451 34.0072 91.8267 33.3916 93.0978C33.3326 93.2158 33.2589 93.3485 33.1999 93.4664H38.2578C39.5115 91.742 40.2481 89.696 40.3812 87.5681C40.3812 86.3948 39.9151 85.2696 39.0855 84.44C38.2559 83.6104 37.1307 83.1443 35.9574 83.1443Z",
    fill: "#5EAC24"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.059 58.0762H38.9065V63.9745H30.059V58.0762Z",
    fill: "#F1F2F2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.059 69.8729H38.9065V75.7713H30.059V69.8729Z",
    fill: "#F1F2F2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.059 46.2795H38.9065V52.1779H30.059V46.2795Z",
    fill: "#F1F2F2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8049 34.4828H19.7368L24.1606 40.3812H44.8049V34.4828Z",
    fill: "#006DF0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6189 19.7368H40.3811L44.8049 25.6352H80.1951L84.6189 19.7368Z",
    fill: "#2488FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1951 93.4664H100.839V99.3648H80.1951V93.4664Z",
    fill: "#8B5E3C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1606 93.4664H44.8049V99.3648H24.1606V93.4664Z",
    fill: "#8B5E3C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8049 25.6353H80.1951V28.5844H44.8049V25.6353Z",
    fill: "#EBBF00"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1951 40.3811H100.839V43.3303H80.1951V40.3811Z",
    fill: "#CCA400"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1606 40.3811H44.8049V43.3303H24.1606V40.3811Z",
    fill: "#CCA400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApr);
export default __webpack_public_path__ + "static/media/apr.43dbc611c751d43e394517052576d12d.svg";
export { ForwardRef as ReactComponent };